/**
 * @function handleFormSubmit
 * @param {function} onSuccess
 * @param {function} onError
 * @returns {function} onSubmit event callback
 * @description Factory function to create React Synthetic onSubmit event
 * handlers for form submission. onSubmit handler will fetch and parse the response.
 * onSuccess will be called with resolved data, onError will be called with any errors.
 * Your form element must have action and method attributes.
 * @example
 *
 * import { handleFormSubmit } from "utils/handle-form-submit";
 *
 * <form
 *   action="https://api.demo.com/contactUs"
 *   method="post"
 *   onSubmit={handleFormSubmit(console.log, console.warn)}
 * >
 *   <input type="text" name="name" />
 *   <button type="submit" name="submit">submit</button>
 * </form>
 */
export function handleFormSubmit(onSuccess, onError) {
  return function(submitEvent) {
    submitEvent.preventDefault();

    const formElement = submitEvent.target;
    const resource = formElement.getAttribute("action");
    const method = formElement.getAttribute("method");
    // const contentType = formElement.getAttribute("encType");

    fetch(resource, {
      body: new FormData(formElement),
      method,
    })
      .then(async response => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.text().then(text => {
          try {
            const data = JSON.parse(text);
            return Promise.resolve(data);
          } catch (err) {
            if (response.headers.get("content-type") === "application/json") {
              return Promise.reject();
            }
            return Promise.resolve(text);
          }
        });
      })
      .then(onSuccess)
      .catch(onError);
  };
}
